import { createFileRoute } from '@tanstack/react-router';

import { ReviewsPage } from '@/features/reviews/reviews-page';

// TEMPORARY test route: the list with no review, to check the empty state. Remove with it.
export const Route = createFileRoute('/_app/reviews/empty')({
  component: () => <ReviewsPage empty />,
});
